// Helpers for the local .dsymbia project file (state + Base64-bundled geometry).

const MODEL_EXTS = ["3dm", "obj", "glb", "gltf"];

function arrayBufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  const chunk = 0x8000; // avoid call-stack limits on large models
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
  }
  return btoa(binary);
}

function base64ToArrayBuffer(base64) {
  const binary = atob(base64);
  const len = binary.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);
  return bytes.buffer;
}

// Read an uploaded model File into a { name, ext, base64 } descriptor for bundling.
export async function fileToSource(file) {
  const ext = file.name.split(".").pop().toLowerCase();
  const buffer = await file.arrayBuffer();
  return { name: file.name, ext, base64: arrayBufferToBase64(buffer) };
}

// Reconstruct a browser File from a bundled { name, base64 } so it can be re-ingested.
export function sourceToFile(model) {
  if (!model?.base64) return null;
  const buffer = base64ToArrayBuffer(model.base64);
  return new File([buffer], model.name || "model.3dm", { type: "application/octet-stream" });
}

export function sanitizeFilename(name) {
  return (name || "dsymbia-project").replace(/[^a-z0-9\-_ ]/gi, "").trim().replace(/\s+/g, "-").slice(0, 60) || "dsymbia-project";
}

// Serialize + trigger a native download of the project as [name].rcengine
export function downloadProject(data) {
  const blob = new Blob([JSON.stringify(data)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${sanitizeFilename(data.projectName)}.rcengine`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// Accept the current .rcengine extension AND the legacy .dsymbia so older saves still open.
export function isDsymbiaFile(name) {
  return /\.(rcengine|dsymbia)$/i.test(name || "");
}

export { MODEL_EXTS };
